import { isBrowser as l } from "@smh/utils/is-in-browser";
const t = (e) => setTimeout(() => {
  const a = Date.now();
  e({
    didTimeout: !1,
    timeRemaining: function() {
      return Math.max(0, 50 - (Date.now() - a));
    }
  });
}, 1), c = (e) => {
  clearTimeout(e);
}, o = l() && "requestIdleCallback" in window ? window.requestIdleCallback : t, i = l() && "cancelIdleCallback" in window ? window.cancelIdleCallback : c;
export {
  i as cancelIdleCallback,
  o as requestIdleCallback
};
